// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"FormsSubmissionsCount_contentWrapper__NXIVz"};